module.exports = __webpack_public_path__ + "static/media/tetra-logo-sm.4ef06af3.png";